// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/common/font/font.scss'
import '@/common/css/default.scss'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import util from './utils/utils'
import '../static/css/index.scss'
import axios from 'axios'

window.Utils = util
Vue.config.productionTip = false
Vue.use(ElementUI, {locale})
Vue.prototype.$box = util
Vue.prototype.$axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js